// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "grafana." + ({"190":"geomapPanel","8926":"react-monaco-editor"}[chunkId] || chunkId) + "." + {"190":"aacf80d11011e67cf843","856":"a45e45977094df4a0bc9","6503":"ffb3a9cd952d3cd7471b","8926":"ffb3a9cd952d3cd7471b"}[chunkId] + ".css";
};